var h             = require('virtual-dom/h');
var createElement = require('virtual-dom/create-element');
var moment        = require('moment');
var diff          = require("virtual-dom/diff");
var patch         = require('virtual-dom/patch');
var Rx            = require('ub_wrapped/rx');
var ubBanzai = require('ub/control/banzai-features');
var isSandboxMode = ubBanzai.features.isSandboxEnabled();

var VersionControlButton = function(buttonHandler, hasSaved, saveObs) {
  this.buttonHandler = buttonHandler;

  if (hasSaved && !isSandboxMode) {
    this.renderInIntervals();
  } else {
    this._render(this._createNoSavesTree());
  }

  saveObs
  .filter(function(ev) {
    return ev.type === 'pageSaveCompleted';
  })
  .subscribe(function(){
    this.renderInIntervals();
  }.bind(this));
};

VersionControlButton.prototype = {
  renderInIntervals: function() {
    this._renderTimeSinceButton();

    this.intervalObs = this.intervalObs || Rx.Observable.interval(60000).subscribe(function() {
      this._renderTimeSinceButton();
    }.bind(this));
  },

  _renderTimeSinceButton: function() {
    this._render(this._createTimeSinceSaveTree());
  },

  _render: function(newTree) {
    if (this.buttonTree) {
      var patches = diff(this.buttonTree, newTree);
      this.element = patch(this.element, patches);
    } else {
      this.element = createElement(newTree);
    }

    this.buttonTree = newTree;

    return this.element;
  },

  _createNoSavesTree: function() {
    var spanLabel = h('span.version-control-button.editor-header-button-label', 'No previous versions saved');
    return h('div.version-control-button-container.editor-header-button', spanLabel);
  },

  _createTimeSinceSaveTree: function() {
    var timeSinceLastSave = moment(window.editor.updatedAt).fromNow();
    var savedDate = h('span.sub-span', timeSinceLastSave);
    var spanLabel = h('span', 'Last saved ');
    var buttonLink = h('a.version-control-button.editor-header-button-label',
      { 'ev-click' : this.buttonHandler },
      [spanLabel, savedDate]
    );
    return h('div.version-control-button-container.editor-header-button', buttonLink);
  }
};

module.exports = VersionControlButton;



// WEBPACK FOOTER //
// ./src/lp/editor/buttons/version-control-button.js